<template>
  <TableLayout v-permissions="['generate:record:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="搜索关键字" prop="keywords">
        <el-input v-model="searchForm.keywords" placeholder="请输入搜索关键字" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="行业" prop="industryId">
        <IndustrySelect v-model="searchForm.industryId" clearable @change="search"/>
      </el-form-item>
      <el-form-item label="部署状态" prop="deployStatus">
        <el-select v-model="searchForm.deployStatus" clearable @change="search">
          <el-option label="部署中" value="ING"/>
          <el-option label="运行中" value="RUNNING"/>
          <el-option label="部署失败" value="FAILED"/>
          <el-option label="已停止" value="CLOSE"/>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="keywords">
        <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['generate:record:create', 'generate:record:delete']">
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['generate:record:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        :row-class-name="getRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="记录ID" min-width="80px"></el-table-column>
        <el-table-column prop="template.name" label="系统类型" min-width="100px"></el-table-column>
        <el-table-column prop="systemName" label="系统名称" min-width="140px"></el-table-column>
        <el-table-column prop="systemLogo" label="系统LOGO" min-width="100px">
          <template slot-scope="{ row }">
            <img v-if="row.systemLogo != null && row.systemLogo !== ''" :src="row.systemLogo">
            <template v-else>默认LOGO</template>
          </template>
        </el-table-column>
        <el-table-column prop="systemLoginImage" label="系统登录大图" min-width="100px">
          <template slot-scope="{ row }">
            <img v-if="row.systemLoginImage != null && row.systemLoginImage !== ''" :src="row.systemLoginImage">
            <template v-else>默认大图</template>
          </template>
        </el-table-column>
        <el-table-column prop="keywords" label="搜索语句" min-width="100px"></el-table-column>
        <el-table-column prop="industry.name" label="行业" min-width="100px"></el-table-column>
        <el-table-column prop="industryKeywords" label="行业关键字（当时）" min-width="130px"></el-table-column>
        <el-table-column prop="matchKeywords" label="匹配关键字" min-width="130px"></el-table-column>
        <el-table-column prop="task.accessUrl" label="部署地址" min-width="180px"></el-table-column>
        <el-table-column prop="task.console" label="部署控制台" min-width="140px">
          <ColumnDetail slot-scope="{ row }" :content="row.task == null ? '' : row.task.console"/>
        </el-table-column>
        <el-table-column prop="task.console" label="部署状态" min-width="140px">
          <template slot-scope="{ row }">{{ (row.task == null ? null : row.task.status) | deployStatusText }}</template>
        </el-table-column>
        <el-table-column prop="parameter" label="生成参数" min-width="100px">
          <ColumnDetail slot-scope="{ row }" :content="row.parameter"/>
        </el-table-column>
        <el-table-column prop="parameterUnique" label="生成参数标识" min-width="100px">
          <ColumnDetail slot-scope="{ row }" :content="row.parameterUnique"/>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="{ row }">{{ row.status | statusText }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="生成时间" min-width="140px"></el-table-column>
        <el-table-column prop="createUserInfo.realname" label="生成人" min-width="120px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['generate:record:update', 'generate:record:delete', 'generate:record:deploy'])"
          label="操作"
          min-width="380"
          fixed="right"
          >
          <template slot-scope="{row}">
            <el-dropdown size="mini" :hide-on-click="hideOnClick" trigger="click">
              <span class="el-dropdown-link">
                导出文档<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu :slot="!hideOnClick ? 'dropdown' : ''">
                <el-dropdown-item>
                  <el-button type="text" @click="exportBook(row)" icon="el-icon-upload2" :disabled="row._exportBooking">{{row._exportBooking ? '导出中...': '招标书文档'}}</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button type="text" @click="exportCodeBook(row)" icon="el-icon-upload2" :disabled="row._exportCodeBooking">{{row._exportCodeBooking ? '导出中...': '代码文档'}}</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button type="text" @click="simpExportCodeBook(row)" icon="el-icon-upload2" :disabled="row._simpExportCodeBooking">{{row._simpExportCodeBooking ? '导出中...': '精简版代码文档'}}</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button type="text" @click="exportSystemBook(row)" icon="el-icon-upload2" :disabled="row._exportSystemBook">{{row._exportSystemBook ? '导出中...': '系统介绍文档'}}</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="text" @click="regen(row)" icon="el-icon-position" :disabled="row._generating || row.status === 'GENERATING'">{{row._generating ? '生成中...': '获取代码'}}</el-button>
            <!-- 部署 -->
            <el-button
              v-if="row.task == null || row.task.status === 'CLOSE' || row.task.status === 'FAILED'"
              v-permissions="['generate:record:deploy']"
              type="text"
              @click="deployById(row)"
              :disabled="row._deploying"
              icon="el-icon-s-promotion"
            >部署</el-button>
            <!-- 停止部署 -->
            <el-button
              v-else
              v-permissions="['generate:record:deploy']"
              type="text"
              @click="stopDeployById(row)"
              :disabled="row._killing"
              icon="el-icon-s-promotion"
            >关闭部署</el-button>
            <el-button type="text" @click="edit(row)" icon="el-icon-edit" v-permissions="['generate:record:update']">编辑</el-button>
            <!-- 删除 -->
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['generate:record:delete']">删除</el-button>
            <!-- 备注 -->
            <el-button type="text" @click="editRemark(row)" icon="el-icon-notebook-1" v-permissions="['generate:record:update']">备注</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import ColumnDetail from '@/components/common/ColumnDetail'
import {
  exportBook,
  exportCodeBook,
  simpExportCodeBook,
  regen,
  exportSystemBook,
  updateById
} from '@/api/generate/list'
import IndustrySelect from '@/components/runner/IndustrySelect'

export default {
  name: 'GenerateRecordList',
  extends: BaseTable,
  components: { IndustrySelect, ColumnDetail, TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        keywords: '',
        industryId: '',
        deployStatus: '',
        remark: ''
      },
      hideOnClick: false,
      // 任务轮询
      loopTimeouts: []
    }
  },
  filters: {
    // 部署状态文案
    deployStatusText (value) {
      if (value == null) {
        return '待部署'
      }
      if (value === 'FAILED') {
        return '部署失败'
      }
      if (value === 'RUNNING') {
        return '运行中'
      }
      if (value === 'CLOSE') {
        return '已停止'
      }
      if (value === 'ING') {
        return '部署中'
      }
      return '未知'
    },
    // 状态文案
    statusText (value) {
      if (value === 'SUCCESS') {
        return '已获取'
      }
      if (value === 'FAILED') {
        return '获取失败'
      }
      if (value === 'GENERATING') {
        return '获取中'
      }
      if (value === 'NONE') {
        return '暂未获取'
      }
      return '未知状态'
    }
  },
  methods: {
    // 编辑
    edit (row) {
      this.$router.push({ name: 'generator', query: { id: row.id } })
    },
    // 编辑备注
    editRemark (row) {
      this.$prompt('请输入备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: `${row.remark === null ? '' : row.remark}`,
        inputType: 'textarea',
        closeOnClickModal: false
      }).then(({ value }) => {
        updateById({
          id: row.id,
          remark: value
        })
          .then(() => {
            this.handlePageChange()
            this.$tip.success('编辑成功')
          })
          .catch(e => {
            this.$tip.apiFailed(e)
          })
      })
    },
    // 部署
    deployById (row) {
      this.$set(row, '_deploying', true)
      this.api.deployById(row.id)
        .then(() => {
          this.$tip.success('部署任务已开启')
          this.__refresh()
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          row._deploying = false
        })
    },
    // 停止部署
    stopDeployById (row) {
      this.$set(row, '_killing', true)
      this.api.killDeployById(row.task.id)
        .then(() => {
          this.$tip.success('关闭成功')
          this.__refresh()
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          row._killing = false
        })
    },
    // 获取行class，根据状态区分出行
    getRowClassName ({ row }) {
      const classes = []
      if (row.status === 'SUCCESS') {
        classes.push('success-row')
      } else if (row.status === 'FAILED') {
        classes.push('failed-row')
      } else if (row.status === 'GENERATING') {
        classes.push('generating-row')
      }
      if (row.task != null && row.task.status === 'ING') {
        classes.push('deploying-row')
      }
      if (row.task != null && row.task.status === 'RUNNING') {
        classes.push('running-row')
      }
      return classes.join(' ')
    },
    // 导出招标书
    exportBook (row) {
      if (row._exportBooking) {
        return
      }
      this.$set(row, '_exportBooking', true)
      this.hideOnClick = false
      exportBook(row.id)
        .then(data => {
          this.download(data)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.hideOnClick = true
          this.$nextTick(() => {
            this.hideOnClick = false
          })
          row._exportBooking = false
        })
    },
    // 导出代码文档
    exportCodeBook (row) {
      if (row._exportCodeBooking) {
        return
      }
      this.$set(row, '_exportCodeBooking', true)
      this.hideOnClick = false
      exportCodeBook(row.id)
        .then(data => {
          this.download(data)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.hideOnClick = true
          this.$nextTick(() => {
            this.hideOnClick = false
          })
          row._exportCodeBooking = false
        })
    },
    // 系统说明文档
    exportSystemBook (row) {
      if (row._exportSystemBook) {
        return
      }
      this.$set(row, '_exportSystemBook', true)
      this.hideOnClick = false
      exportSystemBook(row.id)
        .then(data => {
          this.download(data)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.hideOnClick = true
          this.$nextTick(() => {
            this.hideOnClick = false
          })
          row._exportSystemBook = false
        })
    },
    // 导出精简版代码文档
    simpExportCodeBook (row) {
      if (row._simpExportCodeBooking) {
        return
      }
      this.hideOnClick = false
      this.$set(row, '_simpExportCodeBooking', true)
      simpExportCodeBook(row.id)
        .then(data => {
          this.download(data, `${row.keywords}-代码文档.docx`)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.hideOnClick = true
          this.$nextTick(() => {
            this.hideOnClick = false
          })
          row._simpExportCodeBooking = false
        })
    },
    // 获取代码
    regen (row) {
      if (row._generating) {
        return
      }
      // 如果已经获取过，则做二次提醒
      if (row.status === 'SUCCESS') {
        this.$dialog.confirm('代码已经被获取过，确定要重新获取吗？', '提醒', {
          type: 'warning',
          confirmButtonText: '重新获取',
          cancelButtonText: '取消'
        })
          .then(() => {
            this.doRegen(row)
          })
          .catch(() => {})
        return
      }
      this.doRegen(row)
    },
    // 执行获取代码
    doRegen (row) {
      if (row._generating) {
        return
      }
      row.status = 'GENERATING'
      this.$set(row, '_generating', true)
      regen(row.id)
        .then(data => {
          row.status = 'SUCCESS'
          this.download(data)
        })
        .catch(e => {
          row.status = 'FAILED'
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          row._generating = false
        })
    },
    // 分页查询
    handlePageChange (pageIndex) {
      this.__checkApi()
      this.tableData.pagination.pageIndex = pageIndex || this.tableData.pagination.pageIndex
      this.isWorking.search = true
      this.api.fetchList({
        page: this.tableData.pagination.pageIndex,
        capacity: this.tableData.pagination.pageSize,
        model: this.searchForm,
        sorts: this.tableData.sorts
      })
        .then(data => {
          this.tableData.list = data.records
          this.tableData.pagination.total = data.total
          // 开启部署中的任务轮询
          for (const id of this.loopTimeouts) {
            clearTimeout(id)
          }
          const deployingRecords = this.tableData.list.filter(item => item.task != null && item.task.status === 'ING')
          for (const record of deployingRecords) {
            this.__loopTask(record)
          }
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.search = false
        })
    },
    // 轮询部署任务
    __loopTask (row) {
      this.loopTimeouts.push(setTimeout(() => {
        this.api.findDeployTaskById(row.task.id)
          .then(task => {
            if (task.status !== 'ING') {
              Object.assign(row.task, task)
              return
            }
            this.__loopTask(row)
          })
          .catch(e => {
            console.error && console.error(e)
          })
      }, 5000))
    }
  },
  created () {
    this.config({
      module: '生成记录',
      api: '/generate/list',
      'field.id': 'id',
      'field.main': 'id',
      sorts: [
        {
          property: 'record.CREATE_TIME',
          direction: 'DESC'
        }
      ]
    })
    this.search()
  }
}
</script>
<style scoped lang="scss">
  .el-dropdown-link {
    cursor: pointer;
    color: #2E68EC;
    font-size: 12px;
    font-weight: bold;
    margin-right: 10px;
  }
  .el-table {
    /deep/ img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }
    // 进行中
    /deep/ .generating-row {
      * {
        color: green;
      }
      *[disabled] {
        opacity: .5;
      }
    }
    // 成功
    /deep/ .success-row {
      $background: #eee;
      background: $background !important;
      td {
        background: $background !important;
      }
      &.hover-row td {
        background: $background !important;
      }
    }
    // 失败
    /deep/ .failed-row {
      * {
        color: indianred;
      }
      *[disabled] {
        opacity: .5;
      }
    }
    // 运行中
    /deep/ .deploying-row, /deep/ .running-row,  {
      td:first-of-type {
        position: relative;
        &::before {
          position: absolute;
          top: 50%;
          margin-top: -6px;
          left: 6px;
          display: block;
          content: '';
          width: 10px;
          height: 10px;
          background-color: #0ad6a3;
          border-radius: 50%;
        }
      }
    }
    /deep/ .deploying-row {
      td:first-of-type {
        &::before {
          animation: shine ease 1s infinite;
        }
      }
    }
  }
  @keyframes shine {
    0% {
      background-color: #0ad6a3;
    }
    50% {
      background-color: #f7f7f7;
    }
    100% {
      background-color: #0ad6a3;
    }
  }
</style>
